module.exports = __webpack_public_path__ + "media/images/flag_pt-47a5d1881201aef88898896fdfba7377.png";